module.exports = __webpack_public_path__ + "img/card-bg0.5df2cc8b.png";